import { useLocale } from "../../i18n/context";
import { Globe } from "lucide-react";

export function LanguageSwitcher() {
  const { locale, switchLocaleUrl } = useLocale();
  const label = locale === "lt" ? "RU" : "LT";

  return (
    <a
      href={switchLocaleUrl()}
      className="inline-flex items-center gap-1.5 text-slate-300 hover:text-white transition-colors text-sm font-medium no-underline"
    >
      <Globe className="w-3.5 h-3.5" />
      {label}
    </a>
  );
}
